import { Box, Typography } from '@mui/material'
import { WELCOME } from '~/config/tenantCopy'

/** Wave-6 §3 (D4): always-on demo scene-setter above the pinned collection — the wave-4
 *  soft-zone treatment + eyebrow kicker. Sits outside the export capture (and carries
 *  data-export-skip belt-and-braces). Renders nothing when the tenant has no copy. */
export function WelcomePanel() {
  if (!WELCOME) return null
  return (
    <Box
      data-testid="welcome-panel"
      data-export-skip="true"
      sx={{ bgcolor: 'grey.100', borderRadius: 1, px: 2, py: 1.5, maxWidth: '64em', mb: 3 }}
    >
      <Typography variant="eyebrow" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
        {WELCOME.eyebrow}
      </Typography>
      <Typography variant="body2" sx={{ lineHeight: 1.55 }}>
        {WELCOME.text}
      </Typography>
    </Box>
  )
}
